import React from 'react';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
} from 'react-router-dom';

import { HashLink } from 'react-router-hash-link';
import SocialMediaIcon from '../components/SocialMediaIcon';

const Footer = () => {
    return (
        <footer className="relative clear-both shadow-xl">
            <div className="grid grid-rows-1 text-center lg:grid-cols-2 bg-dinshaw-secondary">
                <div className='lg:border-r border-b lg:border-b-0 border-0 border-white py-4 lg:py-12'>
                    <h2 className='flex justify-center text-white'>
                        For trade enquiries and feedback
                    </h2>
                    <div className='flex justify-center'>
                        <HashLink to="/contact-us#enquiry"><button className="flex my-2 lg:my-6 py-2 lg:py-3 px-6 text-white rounded-full bg-dinshaw-theme text-base lg:text-xl">Contact Us</button></HashLink>
                    </div>
                </div>

                <div className='py-4 lg:py-12'>
                    <h2 className='flex justify-center text-white'>
                        To join Dinshaw’s family
                    </h2>
                    <div className='flex justify-center'>
                        <HashLink to="/careers#career-openings"><button className="flex my-2 lg:my-6 lg:py-3 py-2 px-6 text-white rounded-full bg-dinshaw-theme text-base lg:text-xl">Contact Us</button></HashLink>
                    </div>
                </div>
            </div>

            <div className="bg-dinshaw-theme relative text-base font-bold lg:text-lg text-white w-full h-full hidden lg:block">
                <div className="flex flex-wrap flex-row">
                    <div className='-mt-1 px-16'>
                        <Link to="/"><img className='dinshaw-logo pl-4  lg:pl-0  h-28 w-24 lg:h-48 lg:w-auto' src="/dinshaws-logo-footer.jpg"></img></Link>
                    </div>

                    <nav className='w-1/4 py-8 pb-24 flex justify-center'>
                        <ul className='m-4'>
                            <li className='p-1'>
                                <Link to="/"><span className='hover:underline'>Home</span></Link>
                            </li>
                            <li className='p-1'>
                                <Link to="/about-us"><span className='hover:underline'>About Us</span></Link>
                                <ul className='m-2 hidden lg:block'>
                                    <li className='p-1 pl-4'> <HashLink to="/about-us#story"><span className='hover:underline'>Our Story</span></HashLink></li>
                                    <li className='p-1 pl-4'><HashLink to="/about-us#presence"><span className='hover:underline'>Our Presence</span></HashLink></li>
                                    <li className='p-1 pl-4'><HashLink to="/about-us#values"><span className='hover:underline'>Values</span></HashLink></li>
                                    <li className='p-1 pl-4'><HashLink to="/about-us#manufacturing"><span className='hover:underline'>Manufacturing</span></HashLink></li>
                                    <li className='p-1 pl-4'><HashLink to="/about-us#mission"><span className='hover:underline'>Mission</span></HashLink></li>
                                    <li className='p-1 pl-4'><HashLink to="/about-us#certification"><span className='hover:underline'>Certifications</span></HashLink></li>
                                </ul>
                            </li>
                            <li className='p-0'>
                                <Link to="/legacy"><span className='hover:underline'>Our Legacy</span></Link>
                            </li>
                        </ul>
                    </nav>

                    <nav className='w-1/4 py-8 pb-24 flex justify-center'>
                        <ul className='m-4'>
                            <li className='p-1'>
                                <Link to="/products"><span className='hover:underline'>Products</span></Link>
                                <ul className='m-2 hidden lg:block'>
                                    <li className='p-1 pl-4'><Link to="/product/101"><span className='hover:underline'>Milk</span></Link></li>
                                    <li className='p-1 pl-4'><Link to="/product/102"><span className='hover:underline'>Milk Products</span></Link></li>
                                    <li className='p-1 pl-4'><Link to="/product/103"><span className='hover:underline'>Ice Cream</span></Link></li>
                                    <li className='p-1 pl-4'><Link to="/product/104"><span className='hover:underline'>Bakery</span></Link></li>
                                    <li className='p-1 pl-4'><Link to="/product/105"><span className='hover:underline'>Namkeen</span></Link></li>                                    
                                </ul>
                            </li>
                            <li className='p-1 pt-0'><HashLink to="/contact-us#contact"><span className='hover:underline'>Contact Us</span></HashLink></li>
                            <li className='p-1'><HashLink to="/careers#career-openings"><span className='hover:underline'>Careers</span></HashLink></li>
                            <li className='p-1'><HashLink to="/contact-us#enquiry"><span className='hover:underline'>Business Enquiry / Feedback</span></HashLink></li>
                            <li className='p-1'><Link to="/"><span className='hover:underline'>App Privacy Policy</span></Link></li>
                        </ul>
                    </nav>
                    <nav className='w-1/4 py-8 pb-24  m-4 flex justify-end'>
                        <div>
                            <div className='p-2'>Dinshaw's Dairy Foods Pvt. Ltd.,</div>
                            <div className='p-2'>Gorewada Road, Borgaon, Gittikhadan, Nagpur - 440013.</div>
                            <div className='p-2'>(Maharashtra) India.</div>
                            <div className='mt-4'>
                                <div className='p-2'>1800 120 9999 <span className='text-xs'>(All days from 9 am to 6 pm except Sundays & public holidays)</span></div>
                            </div>
                            <div className='p-2'>customerdelight@dinshaws.co.in</div>
                        </div>
                    </nav>
                </div>
                <div className="text-lg absolute ml-4 lg:ml-12 bottom-4">
                    <div className="flex flex-row mt-4">
                        <SocialMediaIcon smLink="https://www.facebook.com/DinshawsOfficial/" icon="/assets/static/images/sm-icon-12.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://www.instagram.com/dinshaws_official/" icon="/assets/static/images/sm-icon-11.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://twitter.com/DinshawOfficial" icon="/assets/static/images/sm-icon-10.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://www.youtube.com/channel/UCxQiQC8aoCNSIARD5Ot6sEg" icon="/assets/static/images/sm-icon-09.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://www.linkedin.com/company/dinshaw's" icon="/assets/static/images/linkedin-icon.webp"></SocialMediaIcon>
                    </div>
                    <div className='my-4 mt-12'>
                        Copyright@2022 Dinshaws | Made by Evolve Digitas
                    </div>
                </div>
            </div>

            <div className="bg-dinshaw-theme relative text-xs lg:font-bold sm:text-base  lg:text-lg text-white w-full h-full lg:hidden">
                <div className="flex flex-row sm:pl-8">
                    <div className=''>
                        <Link to="/"><img className='dinshaw-logo pl-4 h-28 w-24' src="/dinshaws-logo-footer.jpg"></img></Link>
                    </div>

                    <nav className='w-2/3 sm:py-16 py-12 sm:pb-24 lg:pb-12 flex justify-end'>
                        <ul className>
                            <li className='py-2'>
                                <Link to="/"><span className='hover:underline'>Home</span></Link>
                            </li>
                            <li className='py-2'>
                                <Link to="/about-us"><span className='hover:underline'>About Us</span></Link>
                            </li>
                            <li className='py-2'>
                                <Link to="/legacy"><span className='hover:underline'>Our Legacy</span></Link>
                            </li>
                            <li className='py-2'>
                                <Link to="/products"><span className='hover:underline'>Products</span></Link>
                            </li>
                            <li className='py-2'><Link to="/contact-us"><span className='hover:underline'>Contact Us</span></Link></li>
                            <li className='py-2'><Link to="/careers"><span className='hover:underline'>Careers</span></Link></li>
                            <li className='py-2'><Link to="/"><span className='hover:underline'>App Privacy Policy</span></Link></li>
                        </ul>
                    </nav>
                </div>
                <div className="absolute ml-4 lg:ml-12 bottom-4 sm:pl-8">
                    <div className='mb-4'>
                        <div className=''>Dinshaw's Dairy Foods Pvt. Ltd.,</div>
                        <div className=''>Gorewada Road, </div>
                        <div className=''>Borgaon, Gittikhadan,</div>
                        <div className=''>Nagpur - 440013</div>
                        <div className=''>(Maharashtra) India.</div>
                    </div>

                    <span>91 712 2865500<br />customerdelight@dinshaws.co.in</span>
                    <div className="flex flex-row mt-4">
                        <SocialMediaIcon smLink="https://www.facebook.com/DinshawsOfficial/" icon="/assets/static/images/sm-icon-12.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://www.instagram.com/dinshaws_official/" icon="/assets/static/images/sm-icon-11.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://twitter.com/DinshawOfficial" icon="/assets/static/images/sm-icon-10.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://www.youtube.com/channel/UCxQiQC8aoCNSIARD5Ot6sEg" icon="/assets/static/images/sm-icon-09.png"></SocialMediaIcon>
                        <SocialMediaIcon smLink="https://www.linkedin.com/company/dinshaw's" icon="/assets/static/images/linkedin-icon.webp"></SocialMediaIcon>
                    </div>
                </div>
            </div>
        </footer>
    )
};
export default Footer;